export default "__VITE_ASSET__973cf9a1__"